// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"c5d4785f","703":"bae61f32","787":"dd6a161a"}[chunkId] + ".chunk.js";
};